import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Waiting = () => {
  const navigate = useNavigate();
  const COUNTDOWN_DURATION = 30; // 30 seconds
  const STORAGE_KEY = 'waiting_countdown_start';

  // Initialize countdown based on stored timestamp or start new
  const getInitialCountdown = () => {
    const startTime = localStorage.getItem(STORAGE_KEY);
    if (startTime) {
      const elapsed = Math.floor((Date.now() - parseInt(startTime)) / 1000);
      const remaining = COUNTDOWN_DURATION - elapsed;
      return remaining > 0 ? remaining : 0;
    }
    // Store current timestamp if not exists
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    return COUNTDOWN_DURATION;
  };

  const [countdown, setCountdown] = useState(getInitialCountdown);

  useEffect(() => {
    // Define handleAutoLogout inside useEffect to avoid dependency warning
    const handleAutoLogout = () => {
      // Clear countdown timestamp
      localStorage.removeItem(STORAGE_KEY);
      // Clear all localStorage items
      localStorage.clear();
      
      // Navigate to login page
      navigate('/');
    };

    // Check if countdown has already expired on mount
    const startTime = localStorage.getItem(STORAGE_KEY);
    if (startTime) {
      const elapsed = Math.floor((Date.now() - parseInt(startTime)) / 1000);
      if (elapsed >= COUNTDOWN_DURATION) {
        // Time already expired, logout immediately
        handleAutoLogout();
        return;
      }
    }

    // Ensure start time is stored
    if (!localStorage.getItem(STORAGE_KEY)) {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    }

    // Start countdown timer when component mounts
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown <= 1) {
          // Time's up - logout automatically
          clearInterval(timer);
          handleAutoLogout();
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000); // Update every second

    // Cleanup interval on component unmount
    return () => {
      clearInterval(timer);
    };
  }, [navigate]);

  return (
    <div className="employee-form">
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card" style={{ 
                maxWidth: '600px', 
                margin: '25px auto',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                border: 'none',
                borderRadius: '8px'
              }}>
                <div className="card-body" style={{ padding: '60px 40px', textAlign: 'center' }}>
                  <div style={{ marginBottom: '30px' }}>
                    <i className="fas fa-clock" style={{ 
                      fontSize: '64px', 
                      color: '#f59e0b',
                      marginBottom: '20px'
                    }}></i>
                  </div>
                  
                  <h2 style={{ 
                    fontSize: '24px', 
                    fontWeight: '600', 
                    color: '#111827',
                    marginBottom: '16px'
                  }}>
                    Waiting For Approval
                  </h2>
                  
                  <p style={{ 
                    fontSize: '16px', 
                    color: '#6b7280',
                    lineHeight: '1.6',
                    marginBottom: '30px'
                  }}>
                    Once admin approved your request, you can able to access the portal.
                  </p>
                  
                  <div style={{ 
                    backgroundColor: '#fef3c7',
                    border: '1px solid #fde68a',
                    borderRadius: '8px',
                    padding: '16px',
                    marginBottom: '30px'
                  }}>
                    <p style={{ 
                      fontSize: '14px', 
                      color: '#92400e',
                      margin: '0',
                      lineHeight: '1.5'
                    }}>
                      <i className="fas fa-info-circle" style={{ marginRight: '8px' }}></i>
                      Please wait for the administrator to review and approve your account.
                    </p>
                  </div>

                  {/* Countdown Timer */}
                  <div style={{ 
                    backgroundColor: '#fee2e2',
                    border: '1px solid #fecaca',
                    borderRadius: '8px',
                    padding: '16px',
                    marginBottom: '20px'
                  }}>
                    <p style={{ 
                      fontSize: '14px', 
                      color: '#991b1b',
                      margin: '0 0 8px 0',
                      lineHeight: '1.5'
                    }}>
                      <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                      You will be automatically logged out in:
                    </p>
                    <div style={{ 
                      fontSize: '32px', 
                      fontWeight: '700', 
                      color: '#dc2626',
                      fontFamily: 'monospace',
                      letterSpacing: '2px'
                    }}>
                      {countdown}
                    </div>
                    <p style={{ 
                      fontSize: '12px', 
                      color: '#991b1b',
                      margin: '8px 0 0 0',
                      lineHeight: '1.5'
                    }}>
                      seconds
                    </p>
                  </div>
                  
                  {/* <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleLogout}
                    style={{
                      padding: '10px 24px',
                      fontSize: '14px',
                      fontWeight: '500',
                      borderRadius: '6px',
                      border: '1px solid #d1d5db',
                      backgroundColor: '#ffffff',
                      color: '#374151',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = '#f3f4f6';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = '#ffffff';
                    }}
                  >
                    <i className="fas fa-sign-out-alt" style={{ marginRight: '8px' }}></i>
                    Logout
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Waiting;
